import ReactCards from 'react-credit-cards-2';
import { useFormContext } from 'react-hook-form';

import privacyIcon from '@/modules/perseo-billing/assets/images/privacy.png';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

type TSpreedlyCardPreviewProps = {
  cardNumberPreview: string;
  cardType: string;
  isCencosud?: boolean;
};

export const SpreedlyCardPreview = (props: TSpreedlyCardPreviewProps) => {
  const { cardNumberPreview, cardType, isCencosud } = props;
  const isMobile = useMediaQuery('md');

  const form = useFormContext<IFormFields>();
  const fullName = form.watch('full_name');
  const expirationDate = form.watch('expiration_date');

  if (isMobile) {
    return <></>;
  }

  {
    return (
      <div
        className={`co-flex co-flex-col co-bg-back-gray co-rounded-8px co-w-full co-p-16px co-gap-24px co-h-fit ${
          isCencosud ? 'cencosud-card' : ''
        }`}
      >
        <ReactCards
          number={cardNumberPreview}
          expiry={expirationDate ? expirationDate : 'MM / AAA'}
          cvc={'***'}
          name={fullName}
          issuer={cardType}
          //   focused={getFocus(focusedInput)}
          placeholders={
            {
              name: 'NOMBRE APELLIDO',
              number: '',
              expiry: 'MM / AA'
            } as {
              name: string;
            }
          }
          locale={{
            valid: ''
          }}
          acceptedCards={[
            'visa',
            'mastercard',
            'american-express',
            'dinersclub'
          ]}
          preview
        />
        <div className="co-flex co-items-center co-justify-center co-gap-8px">
          <div className="co-object-contain">
            <img src={privacyIcon} alt={'product'} width={24} height={24} />
          </div>
          <p className="co-text-body2 co-leading-16px co-text-[#0B0B0B]">
            Tu información está segura con nosotros
          </p>
        </div>
      </div>
    );
  }
};
